module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNy42NjIiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDI3LjY2MiA0Ij4KICA8bGluZSBpZD0iTGluZV81NTciIGRhdGEtbmFtZT0iTGluZSA1NTciIHgyPSIyMy42NjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzFEMzM1NCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1kYXNoYXJyYXk9IjEgNyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/bullet-line.svg
// module id = Tojr
// module chunks = 0